
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.188 4.3V2.688h10.125v10.124h-1.678a7.614 7.614 0 01-.397 1.688h3.2c.31 0 .562-.252.562-.563V1.563A.562.562 0 0018.437 1H6.063a.563.563 0 00-.562.563v3.12A7.61 7.61 0 017.188 4.3z","fill":"#000"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.688 12.25a5.063 5.063 0 1010.125 0 5.063 5.063 0 00-10.126 0zM7.75 5.5a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5z","fill":"#000"}})])
          )
        }
      }
    